<template>
	<div class="my-4"></div>

	<div class="flex items-center gap-2 px-2">
		<div class="bg-base-200 sticky top-0 z-1 flex w-full items-center justify-between gap-2 p-1">
			<input
				type="search"
				class="input input-primary input-sm w-full max-w-xs"
				:placeholder="t('layout.meganav.searchPlaceholder')"
				v-model="_search"
				aria-label="Search" />
		</div>

		<Popper placement="right" trigger="hover" arrow>
			<button class="btn btn-square btn-ghost btn-sm">
				<Cog />
			</button>
			<template #content="{ close }">
				<!-- // Add settings options here: Close -X up right and a checkbox for "Show Archived Projects" -->

				<div class="flex">
					<div class="title">{{ t('layout.meganav.settings') }}</div>
					<div class="btn btn-ghost btn-sm btn-square ml-auto" @click="close">
						<X />
					</div>
				</div>

				<div class="flex items-center">
					<input
						type="checkbox"
						id="show-archived"
						class="checkbox checkbox-sm"
						v-model="showArchivedProjects" />

					<label for="show-archived" class="ml-2">
						{{ t('layout.meganav.showArchived') }}
					</label>
				</div>
			</template>
		</Popper>
	</div>
	<!-- <pre>{{ baseStore.getActiveIds }}</pre> -->
	<ul class="rev-menu">
		<li v-for="project in filteredProjects" :key="project.meta._id" :id="project.meta._id">
			<ul class="" id="meganav-scroll-target">
				<li>
					<RouterLink
						:to="{ name: 'Project', params: { projectId: project.meta._id } }"
						class="__project-title"
						:class="{ _selected: baseStore.getActiveIds.projectId === project.meta._id }">
						<span class="flex w-full flex-col">
							<span class="flex w-full items-center justify-between gap-1">
								<StatusLight type="project" :_id="project.meta._id" />
								<span class="text-lg font-bold">{{ project.meta.projectNumber }}</span>
								<span class="grow"></span>
							</span>

							<span class="condensed">
								{{ project.meta.name }}
							</span>
						</span>
					</RouterLink>
				</li>
				<li v-for="location in project.locations" :key="location.meta._id" class="ml-4">
					<RouterLink
						class="rev-menu-item condensed"
						:class="{ _selected: baseStore.getActiveIds.locationId === location.meta._id }"
						active-class="active"
						:to="{ name: 'Location', params: { locationId: location.meta._id } }">
						<StatusLight type="location" :_id="location.meta._id" />
						{{ location.meta.name }}
					</RouterLink>
				</li>
			</ul>
		</li>
	</ul>
</template>
<script setup lang="ts">
	import { computed, ref, watch } from 'vue'
	import StatusLight from '@/components/StatusLight.vue'
	import { useBaseStore } from '@/stores/base.store'
	// import { useRoute, useRouter } from 'vue-router'
	// import { useLocalStorage } from '@vueuse/core'
	import { ChevronRight, Cog, SquareX, X } from 'lucide-vue-next'
	import Popper from 'vue3-popper'
	import { useI18n } from 'vue-i18n'
	import { _translations as layoutTranslations } from '@/layouts/components/_translations'

	const baseStore = useBaseStore()
	const { t } = useI18n(layoutTranslations)
	// const route = useRoute()
	// const router = useRouter()

	const _search = ref('')
	const projectId = ref<string | null>(null)
	// const locationId = ref<string | null>(null)
	// const modulId = ref<string | null>(null)
	const scrolledAlready = ref(false)
	const showArchivedProjects = ref(false)

	watch(
		projectId,
		(val) => {
			if (!val || scrolledAlready.value) return
			scrolledAlready.value = true
			// const nav = document.getElementById('nav')
			const nav = document.getElementById('meganav-scroll-target')
			const targetElement = document.getElementById(val)
			if (nav && targetElement) {
				targetElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
			}
		},
		{ deep: true, immediate: false },
	)

	const filteredProjects = computed(() => {
		const result =
			baseStore.megalist.projects?.filter((p) => {
				if (!showArchivedProjects.value) return !p.meta?.isArchived
				return true
			}) || []

		if (!_search.value) return result
		else
			return (
				result.filter((p) => {
					return (
						p.meta?.name.toLowerCase().includes(_search.value.toLowerCase()) ||
						p.meta?.projectNumber.toString().includes(_search.value)
					)
				}) || []
			)
	})
</script>

<style scoped>
	@reference '@/styles/tailwind.css';

	.__project-title {
		@apply bg-base-200 block rounded p-2;
		@apply transition-all duration-200 ease-in-out;
		@apply hover:bg-primary/40;
		@apply text-base-content/75 text-sm font-bold;
	}

	._selected {
		/* @apply bg-primary/30; */
		@apply bg-primary/50;
		@apply text-base-content;
		@apply ring-primary ring;
	}
</style>
